import * as React from 'react';
import * as firebase from 'firebase' ; 
import { BaseComponent, BaseComponentState, BaseComponentProps } from '../base/BaseComponent';
import { SecurityData } from '../shared/index';
import { MyAccountMenu } from '../my-account/MyAccountMenu';
import { LoginPanelSimpleUsername } from './LoginPanelSimpleUsername';
import { ModalWrapper, getModalReference } from '../core/index';
import { SignUpPanelSimpleUsername } from './SignUpPanelSimpleUsername';

export interface MyAccountProps extends BaseComponentProps { 
    lang: string; 
    history: History | any;
    user: SecurityData.ApplicationUser;
    user_login: boolean;
    isOpen: boolean;
    userAccess: string;
    hengleUserDialogClose: () => any; 
    firebaseApp: firebase.app.App ; 
}

export interface MyAccountState extends BaseComponentState {
    signup: boolean;
    token?: string | any;
}

export class MyAccount extends BaseComponent<MyAccountProps, MyAccountState> {

    constructor(props: MyAccountProps) {
        super(props);
        let s: MyAccountState = {
            signup: false,
            token: null
        };

        this.state = s;
        try {
            const m: any = getModalReference();
            if (m) {
                if (m.setAppElement) {
                    m.setAppElement('#modal');
                }
            }
        } catch (exc) {
            //
            console.error('Gagal set Modal dialog.erorr : ', exc);
        }

    }

    responseGoogle: (response: any) => any = (response: any) => {
        if (typeof response.error !== 'undefined') {
            console.log("Error");
        } else {
            let x = JSON.parse(JSON.stringify(response));
            console.log(x.w3);
            this.props.hengleUserDialogClose();
        }
    }

    componentClicked: () => any = () => {
        // console.log(response);
    }
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let style: ReactModal.Styles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0, 0.75)',
                zIndex: 9999
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                overflow: 'hidden'
            }
        };
        let ren: any[] = [];
        if (this.state.signup) {
            ren.push(this.renderSignUp());
        } else {
            if (!this.props.user_login) {
                ren.push(this.renderLogin());
            } else {
                let padding: any = 0;
                ren.push(this.renderUser(this.props.user));
                style = {
                    overlay: {
                        position: 'fixed', top: 0,
                        left: 0, right: 0, bottom: 0,
                        backgroundColor: 'rgba(0,0,0, 0.75)',
                        zIndex: 9999
                    },
                    content: {
                        top: '50%', left: '50%',
                        right: 'auto', bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        overflow: 'hidden',
                        padding: padding,
                        border: 0
                    }
                };
            }
        }
        return (
            <ModalWrapper style={style} isOpen={this.props.isOpen} onRequestClose={this.props.hengleUserDialogClose} role="dialog" contentLabel="Minimal Modal Example"  >
                {ren}
            </ModalWrapper>
        );
    }

    renderUser = (user: any) => {
        // console.log(user) 
        return (
            <div key="myaccount">
                <div className="my-user">
                    <div style={{ padding: 25, backgroundColor: 'rgb(90, 153, 236)' }}>
                        <div
                            className="image"
                            style={{
                                backgroundSize: 'cover',
                                backgroundImage: `url("${this.props.user.image_url == null ? '/assets/images/user-icon.png' : this.props.user.image_url}")`
                            }}
                        >{/**/}
                        </div>
                        <div className="name" >{this.props.user.name}<br />{this.props.user.email}</div>
                    </div>
                    <MyAccountMenu 
                        firebaseApp={this.props.firebaseApp}
                        lang={this.props.lang}
                        user={this.props.user}
                        user_login={this.props.user_login}
                        hengleUserDialogClose={this.props.hengleUserDialogClose}
                        userAccess={this.props.userAccess}
                    />
                </div>
            </div>
        );
    }

    renderLogin = () => {
        return (
            <div key="myaccount">
                <h3>Sign In</h3>
                <hr />
                <LoginPanelSimpleUsername  firebaseApp={this.props.firebaseApp}/>
                <hr />
                <div className="form-group col-md-6" style={{ lineHeight: '35px' }}>
                    No Account Yet?
                </div>
                <div className="form-group col-md-6">
                    <button
                        type="submit"
                        className="btn btn-o btn-primary form-control"
                        onClick={() => {
                            this.setState({
                                signup: true
                            });
                        }}
                    > Create Now
                    </button>
                </div>
                <div style={{ marginTop: '20px' }}>
                    <button type="submit" className="btn   form-control btn-primary" onClick={this.props.hengleUserDialogClose}> Close </button>
                </div>
            </div>
        );
    }

    renderSignUp = () => {
        return (
            <div key="myaccount">
                <h3>Sign In</h3>
                <hr />
                <SignUpPanelSimpleUsername hengleUserDialogClose={this.props.hengleUserDialogClose} history={this.props.history} firebaseApp={this.props.firebaseApp}/>
                <hr />
                <div className="form-group col-md-6" style={{ lineHeight: '35px' }}>
                    Have Account?
            </div>
                <div className="form-group col-md-6">
                    <button
                        type="submit"
                        className="btn btn-o btn-primary form-control"
                        onClick={() => {
                            this.setState({
                                signup: false
                            });
                        }}
                    > Sign In
                    </button>
                </div>
                <div style={{ marginTop: '20px' }}>
                    <button type="submit" className="btn   form-control btn-primary" onClick={this.props.hengleUserDialogClose}> Close </button>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/header/MyAccount.tsx